let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9f4oR")).then(() => parcelRequire('9umf9'));